export enum FEATURE_FLAG_STATE {
  DEACTIVATED = 'deactivated',
  ACTIVATED = 'activated'
}
